import { createFileRoute, redirect } from '@tanstack/react-router'

export const redirectLegacyFsnNetworkSettings = ({ params }: { params: { orgId: number } }) => {
  throw redirect({
    to: '/$orgId/settings/integrations/fsn-network',
    params: { orgId: params.orgId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/settings/fsn-network/')({
  loader: redirectLegacyFsnNetworkSettings,
})
